import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

function ContenedoresActivos({
  onClose,
  valorActual,
  actualizarTarifa,
  concepto,
}) {
  const [rkn, setRkn] = useState("");
  const [rap, setRap] = useState("");
  const [reporteTemperatura, setReporteTemperatura] = useState("");

  // 🔹 Cargar datos simulados del back
  useEffect(() => {
    if (valorActual) {
      setRkn(valorActual.rkn || "");
      setRap(valorActual.rap || "");
      setReporteTemperatura(valorActual.reporte_temperatura || "");
    }
  }, [valorActual]);

  const validarCampos = () => {
    if (rkn === "" || rap === "" || reporteTemperatura === "") {
      Swal.fire({
        icon: "error",
        title: "Campos incompletos",
        text: "Todos los campos deben tener un valor",
      });
      return false;
    }

    return true;
  };

  const handleActualizar = () => {
    if (!validarCampos()) return;

    actualizarTarifa(concepto, {
      rkn,
      rap,
      reporte_temperatura: reporteTemperatura,
    });

    Swal.fire({
      title: "Éxito",
      text: "Contenedores activos actualizados correctamente",
      icon: "success",
    }).then(() => {
      onClose();
    });
  };

  const bloquearTeclas = (e) => {
    const teclasPermitidas = [
      "Backspace",
      "Delete",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
    ];

    if (!/[0-9.]/.test(e.key) && !teclasPermitidas.includes(e.key)) {
      e.preventDefault();
    }
  };

  const limpiarInput = (e) => {
    let valor = e.target.value;

    // eliminar todo lo que no sea número o punto
    valor = valor.replace(/[^0-9.]/g, "");

    // evitar más de un punto
    const partes = valor.split(".");
    if (partes.length > 2) {
      valor = partes[0] + "." + partes.slice(1).join("");
    }

    e.target.value = valor;
  };

  return (
    <>
      {/* Aquí va la estructura específica */}
      <div className="container-fluid d-flex justify-content-center align-items-center">
        <div className="text-left" style={{ width: "450px" }}>
          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">
              MANEJO DE CONTENEDORES ACTIVOS (RKN)
            </label>
            <input
              type="number"
              className="form-control"
              step="any"
              onKeyDown={bloquearTeclas}
              onInput={limpiarInput}
              value={rkn}
              onChange={(e) => setRkn(e.target.value)}
            />
          </div>

          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">
              MANEJO DE CONTENEDORES ACTIVOS (RAP)
            </label>
            <input
              type="number"
              className="form-control"
              step="any"
              onKeyDown={bloquearTeclas}
              onInput={limpiarInput}
              value={rap}
              onChange={(e) => setRap(e.target.value)}
            />
          </div>

          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">
              REPORTE DE TEMPERATURA (USD)
            </label>
            <input
              type="number"
              className="form-control"
              step="any"
              onKeyDown={bloquearTeclas}
              onInput={limpiarInput}
              value={reporteTemperatura}
              onChange={(e) => setReporteTemperatura(e.target.value)}
            />
          </div>

          <div className="d-flex justify-content-end">
            <button className="btnn" onClick={handleActualizar}>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContenedoresActivos;
